import renderEnvComponent from 'data/common/renderEnvComponent';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { FHEContainer } from 'data/components';
import { tools } from 'data/common';
import FormBrand from './components/Form/FormBrand';
import { bindActionCreators } from 'redux';
import { addBrand } from '../../data/Brands/actions';
import PropTypes from "prop-types";

class BrandDetail extends Component {
    static propTypes = {
        addBrand: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
    }

    addBrand = data => {
        const { addBrand } = this.props;
        return addBrand(data);
    };
    render() {
        return (
            <FHEContainer withBackIcon>
                <FormBrand type="update" sendDataFunc={this.addBrand} />
            </FHEContainer>
        );
    }
}

const styles = theme => ({});

export default withRouter(
    renderEnvComponent(
        'scenes/Brands/details',
        connect(
            null,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { addBrand }), dispatch),
        )(withStyles(styles, { withTheme: true })(BrandDetail)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Brands/details.js